// components/ChatSystem/ChatInput.jsx
import React, { useState, useRef } from 'react';

const ChatInput = ({ onSendMessage, onVoiceInput, isLoading = false }) => {
  const [inputText, setInputText] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputText.trim() && !isLoading) {
      onSendMessage(inputText.trim());
      setInputText('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !isLoading) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleVoiceClick = () => {
    if (!isLoading) {
      onVoiceInput();
    }
  };

  return (
    <form className="chat-input-form" onSubmit={handleSubmit}>
      <div className="input-container">
        <textarea
          ref={inputRef}
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={isLoading ? "Waiting for response..." : "Type your message..."}
          className="chat-textarea"
          rows="1"
          disabled={isLoading}
        />
        <div className="input-buttons">
          <button
            type="button"
            className="voice-button"
            onClick={handleVoiceClick}
            title="Voice Input"
            disabled={isLoading}
          >
            🎤
          </button>
          <button
            type="submit"
            className="send-button"
            disabled={!inputText.trim() || isLoading}
          >
            {isLoading ? '⏳' : 'Send'}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ChatInput;